import DashboardIcon from '@mui/icons-material/Dashboard'
import * as React from 'react'
import { FC, useEffect, useState } from 'react'

import SubMenu, { MenuItem, SubMenuWithResourcesProps } from 'dash/layout/menu/sub_menu'

type AdminMenuProps = SubMenuWithResourcesProps

export const AdminMenu: FC<AdminMenuProps> = ({ dense, onMenuClick, resources, sidebarIsOpen }) => {
  const [isOpen, setIsOpen] = useState<boolean>(
    false /* don't show admin menu by default. TODO discuss this decision? */
  )
  const [menuItems, setMenuItems] = useState<MenuItem[]>([])

  useEffect(() => {
    if (resources && resources.length > 0) {
      const menuItems: MenuItem[] = [
        {
          name: 'Dashboard',
          route: '/admin',
          icon: DashboardIcon,
        },
        ...resources
      ]

      setMenuItems(menuItems)
    }
  }, [resources])

  return (
    <SubMenu
      dense={dense}
      handleToggle={() => setIsOpen(!isOpen)}
      // icon={<AdminIcon />}
      // isOpen={isOpen}
      isOpen
      menuItems={menuItems}
      name="ADMIN"
      onMenuClick={onMenuClick}
      sidebarIsOpen={sidebarIsOpen}
      subMenuKey="admin"
    />
  )
}
